import { DBDef_ProviderChat } from '@app/advisor-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_BaseAdvisorRuntime } from '../../../modules/ModuleFE_BaseAdvisorRuntime.js';
import { ModuleFE_AdvisorSession } from '../../advisor-session/index.js';
export const dispatch_onProviderChatsUpdated = new ThunderDispatcherV3('__onProviderChatsUpdated');
class ModuleFE_ProviderChat_Class extends ModuleFE_BaseAdvisorRuntime {
    constructor() {
        super(DBDef_ProviderChat, dispatch_onProviderChatsUpdated);
    }
    init() {
        super.init();
        this.setCacheFilter(ModuleFE_AdvisorSession.providerAndEncounterFilter);
    }
}
export const ModuleFE_ProviderChat = new ModuleFE_ProviderChat_Class();
//# sourceMappingURL=ModuleFE_ProviderChat.js.map